import { CommitteeTypeEnum } from "../../../models/Committee";
import {
  RequestRemark,
  Request,
  CommitteeDecision,
} from "../../../models/Request";
import { DEFAULT_REQUEST_REMARK } from "../constants";

interface GetRemarkOrDefaultParams {
  remarks: Request["remarks"];
  remarkTypeId: number;
  requestId: number;
}

export const getRemarkOrDefault = ({
  remarks,
  remarkTypeId,
  requestId,
}: GetRemarkOrDefaultParams): RequestRemark => {
  const foundRemark = remarks?.find(
    (v) => v.requestRemarkTypeId === remarkTypeId
  );

  if (foundRemark) {
    return foundRemark;
  }

  return {
    ...DEFAULT_REQUEST_REMARK,
    requestRemarkTypeId: remarkTypeId,
    requestId,
  };
};

export const shouldShowWarning = (
  committeeDecision: CommitteeDecision | null
) => {
  if (!committeeDecision) return false;

  return (
    committeeDecision?.committeeEmployee?.committeeRole.committeeType ===
      CommitteeTypeEnum.Institution &&
    committeeDecision.request?.outsideEnrollmentAreaInstitutionProgramId
  );
};
